import { Injectable } from '@angular/core';
import { isNil } from 'lodash';

import { EncryptUtil } from '../utils/encrypt.util';
import { Identity } from '../models/Identity';
import { Certificado } from '../models/Certificado';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }
  
  /**
   * @description Set identity information.
   * @param {Identity} identityInfo Customer identity information.
   */
  public setIdentityInformation(identityInfo: Identity): void {
    const infoToken = EncryptUtil.encryptObject(identityInfo);
    sessionStorage.setItem('mb_identity_data', infoToken);
  }

  /**
   * @description Get customer identity information.
   * @return {any} Get object with customer identity information.
   */
  public getIdentityInformation(): any {
    if (!isNil(sessionStorage.getItem('mb_identity_data'))) {
      return EncryptUtil.decryptObject(sessionStorage.getItem('mb_identity_data'));
    } else {
      return undefined;
    }
  }

  /**
   * @description Remove customer identity information.
   */
  public removeIdentityInformation(): void {
    sessionStorage.removeItem('mb_identity_data');
  }

  /**
   * @description Set beneficiaries list.
   * @param {Identity} list Beneficiaries list information.
   */
  public setBeneficiariesList(list: any[]): void {
    const token = EncryptUtil.encryptObject(list ?? []);
    sessionStorage.setItem('mb_beneficiaries_list', token);
  }

  /**
   * @description Get beneficiaries list.
   * @return {any} Get object with beneficiaries list.
   */
  public getBeneficiariesList(): any[] | undefined {
    const raw = sessionStorage.getItem('mb_beneficiaries_list');
    if (isNil(raw)) return undefined;
    return EncryptUtil.decryptObject(raw) as any[];
  }

  /**
   * @description Remove beneficiaries list.
   */
  public removeBeneficiariesList(): void {
    sessionStorage.removeItem('mb_beneficiaries_list');
  }

    /**
   * @description Set certificate details.
   * @param {any} details Certificate details information.
   */
  public setCertificateDetails(details: any): void {
    const token = EncryptUtil.encryptObject(details);
    sessionStorage.setItem('mb_certificate_dtl', token);
  }

  /**
   * @description Get Certificate details.
   * @return {any} Get object with certificate details.
   */
  public getCertificateDetails(): any {
    if (!isNil(sessionStorage.getItem('mb_certificate_dtl'))) {
      return EncryptUtil.decryptObject(sessionStorage.getItem('mb_certificate_dtl'));
    } else {
      return undefined;
    }
  }

  /**
   * @description Remove certificate details.
   */
  public removeCertificateDetails(): void {
    sessionStorage.removeItem('mb_certificate_dtl');
  }
}
